import MapperBase from '../MapperBase.js';
import BaseballPitchType from '../../enums/BaseballPitchType.js';

class MlbPitchTypeMapper extends MapperBase {
    constructor(silent) {
        super(silent, BaseballPitchType.Unidentified.key);
    }

    mapSingle(item) {
        // Unfortunately pitch types listed on MLB glossary are different... https://www.mlb.com/glossary/pitch-types
        /** 
         * Pitch types from data feed are listed here https://www.daktronics.com/en-us/support/kb/DD3312647
         * @see also https://www.kaggle.com/pschale/mlb-pitch-data-20152018 and https://www.gabenespoli.com/blog/mlb-data-description/
         * The following are the Pitch Types generated:
AB Automatic Ball
AS Automatic Strike
CH Change-up
CU Curveball
EP Eephus
FC Cutter
FF Four-Seam Fastball
FO Forkball
FS Splitter
FT Two-Seam Fastball (synonymous with SI)
GY Gyroball
IN Intentional Ball
KC Knuckle Curve
KN Knuckleball
NP No Pitch
PO Pitchout
SC Screwball
SI Sinker (synonymous with FT)
SL Slider
UN Unknown
         */
        switch (item) {
            case 'CH':
                return BaseballPitchType.Changeup.key;
            case 'CU':
                return BaseballPitchType.Curveball.key;
            case 'FC':
                return BaseballPitchType.Cutter.key;
            case 'EP':
                return BaseballPitchType.Eephus.key;
            case 'FO':
                return BaseballPitchType.Forkball.key;
            case 'FA':
            case 'FF':
                return BaseballPitchType.FourSeamFastball.key;
            case 'GY':
                return BaseballPitchType.Gyroball.key;
            case 'SC':
                return BaseballPitchType.Screwball.key;
            case 'KN':
                return BaseballPitchType.Knuckleball.key;
            case 'KC':
                return BaseballPitchType.KnuckleCurve.key;
            case 'SC':
                return BaseballPitchType.Screwball.key;
            case 'SI':
                return BaseballPitchType.Sinker.key;
            case 'SL':
                return BaseballPitchType.Slider.key;
            case 'FS':
                return BaseballPitchType.Splitter.key;
            case 'FT':
                return BaseballPitchType.TwoSeamFastball.key;
            case 'UN':
            case 'NP':
            case 'PO':
            case 'AB':
            case 'AS':
                return BaseballPitchType.Unidentified.key;
        }

        throw new Error(`Unable to map pitch type ${item}`);
    }
}

export default MlbPitchTypeMapper;